import React from "react";

import { Snackbar } from "@mui/material";
import { useSnackBar } from "@/hooks";
import { useRecoilValue } from "recoil";
import { navStatusState } from "@/store/nav-status";
import { PRODUCTION_FLOOR_NESTED_MODAL_Z_INDEX } from "@/widgets/production-floor/utils/proofing-row.styles";

/** Above production-floor nested modals, below their date pickers (+100). */
const SNACKBAR_Z_INDEX = PRODUCTION_FLOOR_NESTED_MODAL_Z_INDEX + 50;

const GoMakeSnackBar = () => {
  const { snackbarStateValue, handleClose, Alert } = useSnackBar();
  const navStatus = useRecoilValue(navStatusState);
  const messageLength = snackbarStateValue.message?.length ?? 0;
  const autoHideDuration =
    snackbarStateValue.type === "error"
      ? Math.min(20000, Math.max(6000, messageLength * 80))
      : 3000;
  const alertSx = {
    whiteSpace: "pre-wrap" as const,
    wordBreak: "break-word" as const,
    maxWidth: 560,
    alignItems: "flex-start" as const,
  };
  return (
    <Snackbar
      open={snackbarStateValue.state}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      style={{ position: "absolute", left: navStatus?.isClosed ? 135 : 250 }}
      sx={{ zIndex: SNACKBAR_Z_INDEX }}
    >
      {snackbarStateValue.type === "error" ? (
        <Alert severity="error" sx={alertSx}>
          {snackbarStateValue.message}
        </Alert>
      ) : snackbarStateValue.type === "warning" ? (
        <Alert severity="warning" sx={alertSx}>
          {snackbarStateValue.message}
        </Alert>
      ) : (
        <Alert severity="success" sx={alertSx}>
          {snackbarStateValue.message}
        </Alert>
      )}
    </Snackbar>
  );
};

export { GoMakeSnackBar };
